const url = "/api/v1/partners";

export type PartnerIndexResponse = {
  data: PartnerSerializer[];
};

export type PartnerSerializer = {
  id: string;
  attributes: {
    name: string;
    slug: string;
    externalId: string;
    nameWithLocation: string;
  };
};

export type Partner = PartnerSerializer["attributes"] & { id: string };
export type PartnerIndexTypes = "all" | "active" | "inactive";

export interface PartnerIndexParams {
  type: PartnerIndexTypes;
}

export const partnerIndexQuery = (
  params: PartnerIndexParams) => ({
  url,
  method: "GET",
  params
});

export const partnerShowQuery = (id: string) => ({
  url: `${url}/${id}`,
  method: "GET",
});

export type PublicPartnerSerializer = {
  id: string;
  attributes: {
    name: string;
    slug: string;
    email: string;
    freeMembership: boolean;
    logoUrl: string | null;
  };
};

export type PartnerBySlugResponse = {
  data: PublicPartnerSerializer;
};

export const partnerBySlugQuery = (slug: string) => ({
  url: `${url}/by_slug/${encodeURIComponent(slug)}`,
  method: "GET",
});